import { CheckboxANTD } from '@zennolab_platform/webui-kit/dist/ui/antdComponents';
import styled from 'styled-components';

export const NotifyAgainCheckbox = styled(CheckboxANTD)`
  align-self: center;
`;
